import { formatString } from "@format-string/core";
import {
  Business as BusinessIcon,
  Badge as BadgeIcon,
  Person as PersonIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ModernCard } from "./shared/ModernCard";
import { ModernInfoItem } from "./shared/ModernInfoItem";
import { ModernGridInfo } from "./shared/ModernGridInfo";

export const CardDadosEmpresaModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  const {
    tipo_contrato,
    razao_social_pj,
    cpf_cnpj,
    contato_responsavel_pj,
    cargo_pj,
  } = valueContractInternal;

  // Só exibe para contratos PJ
  if (tipo_contrato !== "PJ") return null;

  return (
    <ModernCard title="Dados da Empresa" icon={<BusinessIcon />}>
      <ModernGridInfo columns={2}>
        <ModernInfoItem
          icon={<BusinessIcon />}
          label="Razão Social"
          value={razao_social_pj}
          fullWidth
        />
        <ModernInfoItem
          icon={<BadgeIcon />}
          label="CNPJ"
          value={
            formatString({
              type: "cnpj",
              value: cpf_cnpj,
            }) as string
          }
        />
        <ModernInfoItem
          icon={<PersonIcon />}
          label="Responsável"
          value={contato_responsavel_pj}
        />
        <ModernInfoItem
          icon={<WorkIcon />}
          label="Cargo"
          value={cargo_pj}
        />
      </ModernGridInfo>
    </ModernCard>
  );
};
